(function () {
  var JULY_HOVER_IMAGE_DELAY_MS = 1000;

  function isJulySafetyCard(card) {
    if (!card) return false
    return (
      card.getAttribute('data-product-type') === 'Safety' ||
      card.getAttribute('data-safety-split') === 'true'
    )
  }

  function toJuly01ImageSrc(src) {
    if (!src) return src;
    return src.replace(/_02\./g, '_01.').replace(/_02_/g, '_01_');
  }

  function toJuly02ImageSrc(src) {
    if (!src) return src;
    return src.replace(/_01\./g, '_02.').replace(/_01_/g, '_02_');
  }

  function toJulyHoverImageSrc(src) {
    return toJuly01ImageSrc(src);
  }

  function setJulyHoverImageScale(image, scale) {
    if (!image) return;
    if (scale == null || scale === 1) {
      image.style.transform = '';
      return;
    }
    image.style.transform = 'scale(' + scale + ')';
  }

  function clearJulyHoverImageTimer(card) {
    if (!card || !card._julyHoverImageTimer) return;
    clearTimeout(card._julyHoverImageTimer);
    card._julyHoverImageTimer = null;
  }

  function parseJulyImageList(json) {
    try {
      const list = JSON.parse(json || '[]');
      return Array.isArray(list) ? list : [];
    } catch (e) {
      return [];
    }
  }

  function julyImageFileKey(src) {
    return String(src || '').split(/[?#]/)[0].split('/').pop().toLowerCase();
  }

  // Product images the card is currently showing (swapped when a sibling swatch is picked).
  function getJulyCardImages(card) {
    if (!card._julyImages) card._julyImages = parseJulyImageList(card.getAttribute('data-july-images'));
    return card._julyImages;
  }

  // Hover shots are derived from the _01/_02 file naming, but only used when the
  // product really has that file — e.g. "Case_02_Signature-White_02.jpg" would
  // otherwise turn into a non-existent "Case_01_Signature-White_01.jpg".
  function findJulyProductImage(card, src) {
    const key = julyImageFileKey(src);
    if (!key) return null;
    const images = getJulyCardImages(card);
    for (let i = 0; i < images.length; i++) {
      if (julyImageFileKey(images[i]) === key) return images[i];
    }
    return null;
  }

  function startJulyHoverImageSequence(card, baseSrc) {
    const image = card.querySelector('[data-july-image]');
    if (!image) return;

    clearJulyHoverImageTimer(card);

    const source = baseSrc || image.dataset.julyDefaultSrc || image.src;
    if (!source) return;

    if (!image.dataset.julyDefaultSrc && !baseSrc) {
      image.dataset.julyDefaultSrc = source;
    }

    const src01 = findJulyProductImage(card, toJuly01ImageSrc(source));

    // No real _01 shot → nothing to swap to, so don't shrink the same image.
    if (!src01) {
      image.src = source;
      setJulyHoverImageScale(image, 1);
      return;
    }

    const src02 = findJulyProductImage(card, toJuly02ImageSrc(src01));

    image.src = src01;
    setJulyHoverImageScale(image, 0.8);

    // No real _02 counterpart (or same file) → stay on the first shot at 0.8.
    if (!src02 || julyImageFileKey(src02) === julyImageFileKey(src01)) return;

    card._julyHoverImageTimer = setTimeout(function () {
      card._julyHoverImageTimer = null;
      if (!card.classList.contains('is-july-hover')) return;
      const img = card.querySelector('[data-july-image]');
      if (!img) return;
      img.src = src02;
      setJulyHoverImageScale(img, 1);
    }, JULY_HOVER_IMAGE_DELAY_MS);
  }

  function normalizeRxColor(color) {
    return String(color || '').toLowerCase().replace(/-/g, '');
  }

  function isRx02Image(url) {
    return /_02[._]/.test(String(url));
  }

  function getRxColorFromUrl(url) {
    const part = String(url).split('_Rx_').pop();
    if (!part) return '';
    return part.split(/[.?&#]/)[0];
  }

  function findRxLensImageUrl(images, lensColor) {
    if (window.NevenRxCollectionThumb && typeof window.NevenRxCollectionThumb.findRxLensImageUrl === 'function') {
      return window.NevenRxCollectionThumb.findRxLensImageUrl(images, lensColor);
    }
    if (!Array.isArray(images) || !images.length || !lensColor) return null;
    const target = normalizeRxColor(lensColor);
    return images.find(function (url) {
      if (!isRx02Image(url)) return false;
      return normalizeRxColor(getRxColorFromUrl(url)) === target;
    }) || null;
  }

  function getLensColorFromPageUrl() {
    const href = window.location.href || '';
    const typeMap = {
      'type=sunglasses': 'Black',
      'type=lens-color-black': 'Black',
      'type=lens-color-clear': 'Clear',
      'type=lens-color-brown': 'Brown',
      'type=lens-color-yellow': 'Yellow',
      'type=lens-color-coastal-blue': 'Coastal-Blue',
      'type=lens-color-purple-pastel': 'Purple-Pastel',
      'type=lens-color-green-vibrant': 'Green-Vibrant',
      'type=lens-color-photochromic-gray': 'Photochromic-Gray',
      'type=lens-color-photochromic-brown': 'Photochromic-Brown',
      'type=lens-color-rose-pink': 'Rose-Pink',
      'type=lens-color-silver': 'Silver'
    };

    for (const key in typeMap) {
      if (Object.prototype.hasOwnProperty.call(typeMap, key) && href.indexOf(key) !== -1) {
        return typeMap[key];
      }
    }

    const lensMatch = href.match(/[?&]lens=rx-lens-color-([^&#]+)/i);
    if (lensMatch && lensMatch[1]) {
      return decodeURIComponent(lensMatch[1])
        .split('-')
        .map(function (word) {
          return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
        })
        .join('-');
    }

    return '';
  }

  function getOphTypeFromPageUrl() {
    try {
      const params = new URLSearchParams(window.location.search || '');
      const fromUrl = params.get('oph-type');
      if (fromUrl) return fromUrl;
    } catch (e) {}
    return window.collectionOphType || '';
  }

  function syncJulyAtcFromCard(card) {
    const atc = card.querySelector('[data-july-atc]');
    if (!atc) return;

    const productType = card.getAttribute('data-product-type') || '';
    const variantId = card.getAttribute('data-variant-id') || '';
    const handle = card.getAttribute('data-product-handle') || '';
    const productUrl = card.getAttribute('data-product-url') || '';
    const lensColor = card.getAttribute('data-lens-color') || '';

    if (variantId) {
      atc.setAttribute('product-id', variantId);
      atc.setAttribute('data-id', variantId);
    }
    if (handle) atc.setAttribute('data-handle', handle);

    if (productType === 'Prescription') {
      let pdpUrl = productUrl;
      if (lensColor) {
        const base = (productUrl || '').split('?')[0] || ('/products/' + handle);
        pdpUrl = base + '?lens=rx-lens-color-' + lensColor;
      }
      atc.setAttribute('data-pdp-link', pdpUrl);
      atc.setAttribute('data-go-pdp', 'true');
      if (lensColor) {
        // Match live addToCartBtnAction: options[1] = lens color
        atc.setAttribute('data-options', 'Frame / ' + lensColor);
      }
      return;
    }

    if (productUrl) atc.setAttribute('data-pdp-link', productUrl);
  }

  function goToJulyPdp(button, card) {
    let url = button.getAttribute('data-pdp-link') || (card && card.getAttribute('data-product-url')) || '';
    if (!url) return;

    try {
      const linkUrl = new URL(url, window.location.origin);
      const urlParams = new URLSearchParams(window.location.search || '');
      const linkParams = new URLSearchParams(linkUrl.search);
      const skip = [
        '_ab', '_fd', '_sc', 'variant', 'development', 'qty', 'edit', 'lens', 'upgrades',
        'type', 'q', 'token', 'return_url', 'page', 'oph-type', 'lens-color',
        'safety-lens', 'fav-variant-id', 'tab'
      ];
      urlParams.forEach(function (value, key) {
        if (!linkParams.has(key) && skip.indexOf(key) === -1) {
          linkParams.append(key, value);
        }
      });
      linkUrl.search = linkParams.toString();
      window.location.href = linkUrl.toString();
    } catch (e) {
      window.location.href = url;
    }
  }

  function handleJulyAtcClick(card, button) {
    const productType = card.getAttribute('data-product-type') || button.getAttribute('data-type') || '';
    const goPdp = button.getAttribute('data-go-pdp') === 'true';

    // Live theme: Prescription ATC always routes to PDP with lens param
    if (productType === 'Prescription' || goPdp) {
      goToJulyPdp(button, card);
      return;
    }

    // Prefer shared live handler when present (sunglasses / oph bluelight|plain)
    if (typeof window.addToCartBtnAction === 'function') {
      window.addToCartBtnAction({
        preventDefault: function () {},
        target: button
      });
      return;
    }

    addToCart(button);
  }

  function applyOphthalmicTypeFromUrl(card) {
    if (!card || card.getAttribute('data-product-type') !== 'Ophthalmic') return;
    if (card.dataset.julyOphTypeApplied === 'true') return;

    const splitSuffix = card.getAttribute('data-oph-split-suffix') || '';
    const atc = card.querySelector('[data-july-atc]');
    // -bl / -pl cards already render that product's own price/variant in Liquid → ATC
    if (splitSuffix === '-bl' || splitSuffix === '-pl') {
      if (atc) atc.setAttribute('data-go-pdp', 'false');
      card.dataset.julyOphTypeApplied = 'true';
      return;
    }

    const type = getOphTypeFromPageUrl();
    const rewriteHref =
      typeof window.rewriteShopifyProductUrlForOphType === 'function'
        ? window.rewriteShopifyProductUrlForOphType
        : function (href) {
            return href;
          };

    // Live collection__main: no oph-type → ophthalmic ATC goes to PDP
    if (!type) {
      if (atc) {
        const pdp = atc.getAttribute('data-pdp-link') || card.getAttribute('data-product-url') || '';
        atc.setAttribute('data-pdp-link', pdp);
        atc.setAttribute('data-go-pdp', 'true');
      }
      card.dataset.julyOphTypeApplied = 'true';
      return;
    }

    const normalizedType = String(type || '')
      .toLowerCase()
      .trim()
      .replace(/\s+/g, '-')
      .replace('blue-light', 'bluelight');

    if (normalizedType === 'bluelight') {
      const bluelightPrice = card.getAttribute('data-bluelight-price');
      if (bluelightPrice) {
        card.querySelectorAll('[data-july-price]').forEach(function (el) {
          el.textContent = bluelightPrice;
        });
      }

      const image = card.querySelector('[data-july-image]');
      if (image && image.src) {
        const nextSrc = image.src.replace('Rx_Clear', 'BlueLight');
        image.dataset.julyDefaultSrc = nextSrc;
        image.src = nextSrc;
      }

      const bluelightVariantId = card.getAttribute('data-bluelight-variant-id');
      if (bluelightVariantId) {
        card.setAttribute('data-variant-id', bluelightVariantId);
        if (atc) {
          atc.setAttribute('product-id', bluelightVariantId);
          atc.setAttribute('data-id', bluelightVariantId);
          atc.setAttribute('data-go-pdp', 'false');
          const mainHandle = atc.getAttribute('data-handle') || card.getAttribute('data-product-handle') || '';
          if (typeof window.getOphSplitHandleForOphType === 'function' && mainHandle) {
            atc.setAttribute('data-handle', window.getOphSplitHandleForOphType(mainHandle, normalizedType));
          }
        }
      } else if (atc) {
        const pdpUrl = rewriteHref(
          atc.getAttribute('data-pdp-link') || card.getAttribute('data-product-url') || '',
          type
        );
        atc.setAttribute('data-pdp-link', pdpUrl);
        atc.setAttribute('data-go-pdp', 'true');
      }
    } else if (normalizedType === 'plain') {
      const plainPrice = card.getAttribute('data-plain-price');
      if (plainPrice) {
        card.querySelectorAll('[data-july-price]').forEach(function (el) {
          el.textContent = plainPrice;
        });
      }
      const plainVariantId = card.getAttribute('data-plain-variant-id');
      if (plainVariantId) {
        card.setAttribute('data-variant-id', plainVariantId);
        if (atc) {
          atc.setAttribute('product-id', plainVariantId);
          atc.setAttribute('data-id', plainVariantId);
          atc.setAttribute('data-go-pdp', 'false');
          const mainHandle = atc.getAttribute('data-handle') || card.getAttribute('data-product-handle') || '';
          if (typeof window.getOphSplitHandleForOphType === 'function' && mainHandle) {
            atc.setAttribute('data-handle', window.getOphSplitHandleForOphType(mainHandle, normalizedType));
          }
        }
      } else if (atc) {
        const pdpUrl = rewriteHref(
          atc.getAttribute('data-pdp-link') || card.getAttribute('data-product-url') || '',
          type
        );
        atc.setAttribute('data-pdp-link', pdpUrl);
        atc.setAttribute('data-go-pdp', 'true');
      }
    } else if (atc) {
      // readers / prescription / other → PDP with rewritten oph-type URL
      const pdpUrl = rewriteHref(
        atc.getAttribute('data-pdp-link') || card.getAttribute('data-product-url') || '',
        type
      );
      atc.setAttribute('data-pdp-link', pdpUrl);
      atc.setAttribute('data-go-pdp', 'true');
    }

    card.querySelectorAll('[data-july-link]').forEach(function (el) {
      const href = el.getAttribute('href') || '';
      if (!href || href.indexOf('/products/') === -1) return;
      el.setAttribute('href', rewriteHref(href, type));
    });

    const productUrl = card.getAttribute('data-product-url') || '';
    if (productUrl) {
      card.setAttribute('data-product-url', rewriteHref(productUrl, type));
    }

    card.dataset.julyOphTypeApplied = 'true';
  }

  function applySafetyLensFromUrl(card) {
    if (!card || !isJulySafetyCard(card)) return;
    if (card.getAttribute('data-safety-lens')) {
      if (typeof window.filterSafetySplitCards === 'function') window.filterSafetySplitCards();
      return;
    }
    if (card.dataset.julySafetyLensApplied === 'true') return;
    card.dataset.julySafetyLensApplied = 'true';

    const lens = typeof window.getSafetyLensFromUrl === 'function' ? window.getSafetyLensFromUrl() : '';
    if (!lens) return;

    const atc = card.querySelector('[data-july-atc]');

    let lenses = null;
    try {
      lenses = JSON.parse(card.getAttribute('data-safety-lenses') || 'null');
    } catch (e) {}

    const entry = lenses && lenses[lens];
    if (entry) {
      if (entry.price) {
        card.querySelectorAll('[data-july-price]').forEach(function (el) {
          el.textContent = entry.price;
        });
      }
      if (entry.id) {
        card.setAttribute('data-variant-id', String(entry.id));
        if (atc) {
          atc.setAttribute('product-id', String(entry.id));
          atc.setAttribute('data-id', String(entry.id));
          if (entry.title) atc.setAttribute('data-options', entry.title);
        }
      }
    }

    const code = typeof window.getSafetyLensImageCode === 'function' ? window.getSafetyLensImageCode(lens) : '';
    if (code && typeof window.srcMatchesSafetyLensCode === 'function') {
      let images = [];
      try {
        images = JSON.parse(card.getAttribute('data-safety-images') || '[]');
      } catch (e) {}
      const matches = images.filter(function (src) {
        return window.srcMatchesSafetyLensCode(src, code);
      });
      // Cards lead with the _02 shot, and hover steps back to _01
      const nextSrc = matches.filter(isRx02Image)[0] || matches[0];
      const image = card.querySelector('[data-july-image]');
      if (nextSrc && image) {
        image.dataset.julyDefaultSrc = nextSrc;
        image.src = nextSrc;
      }
    }

    const rewriteHref =
      typeof window.rewriteShopifyProductUrlForSafetyLens === 'function'
        ? window.rewriteShopifyProductUrlForSafetyLens
        : function (href) {
            return href;
          };

    const variantId = entry && entry.id ? entry.id : '';

    card.querySelectorAll('[data-july-link]').forEach(function (el) {
      const href = el.getAttribute('href') || '';
      if (!href || href.indexOf('/products/') === -1) return;
      el.setAttribute('href', rewriteHref(href, lens, variantId));
    });

    const productUrl = card.getAttribute('data-product-url') || '';
    if (productUrl) card.setAttribute('data-product-url', rewriteHref(productUrl, lens, variantId));

    if (atc) {
      const pdp = atc.getAttribute('data-pdp-link') || productUrl;
      if (pdp) atc.setAttribute('data-pdp-link', rewriteHref(pdp, lens, variantId));
    }
  }

  function applyJulyHoverImage(card) {
    startJulyHoverImageSequence(card);
  }

  function restoreJulyDefaultImage(card) {
    clearJulyHoverImageTimer(card);
    const image = card.querySelector('[data-july-image]');
    if (!image) return;
    setJulyHoverImageScale(image, 1);
    if (!image.dataset.julyDefaultSrc) return;
    image.src = image.dataset.julyDefaultSrc;
  }

  function updateCardFromSwatch(card, swatch) {
    if (!card || !swatch) return;

    const imageUrl = swatch.getAttribute('data-image-url');
    const title = swatch.getAttribute('data-product-title') || '';
    const titleAlt = swatch.getAttribute('data-title-alt') || '';
    const frameName = swatch.getAttribute('data-frame-name') || '';
    const price = swatch.getAttribute('data-product-price') || '';
    const url = swatch.getAttribute('data-product-url') || '';
    const description = swatch.getAttribute('data-description') || '';
    const variantId = swatch.getAttribute('data-variant-id') || '';
    const productId = swatch.getAttribute('data-product-id') || '';
    const handle = swatch.getAttribute('data-product-handle') || '';
    const lensColor = swatch.getAttribute('data-lens-color') || '';
    const reviewAverage = swatch.getAttribute('data-review-average') || '';
    const reviewCount = swatch.getAttribute('data-review-count') || '';
    const reviewBadge = swatch.getAttribute('data-review-badge') || '';
    const isPrescription = card.getAttribute('data-product-type') === 'Prescription';
    const isSafety = isJulySafetyCard(card);

    const swatchImages = swatch.getAttribute('data-images');
    card._julyImages = swatchImages
      ? parseJulyImageList(swatchImages)
      : parseJulyImageList(card.getAttribute('data-july-images'));

    const image = card.querySelector('[data-july-image]');
    if (image && imageUrl) {
      image.dataset.julyDefaultSrc = imageUrl;
      image.alt = title || image.alt || '';
      if (card.classList.contains('is-july-hover')) {
        startJulyHoverImageSequence(card, imageUrl);
      } else {
        clearJulyHoverImageTimer(card);
        image.src = imageUrl;
      }
    }

    // Prescription swatches are lens colors — never overwrite frame / product titles.
    if (!isPrescription) {
      if (title) {
        card.querySelectorAll('[data-july-title]').forEach(function (el) {
          el.textContent = title;
        });
      }
      if (titleAlt) {
        card.querySelectorAll('[data-july-title-alt]').forEach(function (el) {
          el.textContent = titleAlt;
        });
      }
      if (frameName && !isSafety) {
        card.querySelectorAll('[data-july-frame]').forEach(function (el) {
          el.textContent = frameName;
        });
      }
    }

    card.querySelectorAll('[data-july-price]').forEach(function (el) {
      el.textContent = price;
    });

    card.querySelectorAll('[data-july-description]').forEach(function (el) {
      el.textContent = description;
    });

    card.querySelectorAll('[data-july-link]').forEach(function (el) {
      if (url) el.setAttribute('href', url);
    });

    if (!isPrescription) {
      const reviewsFull = card.querySelector('[data-july-reviews-full]');
      if (reviewsFull && reviewBadge) {
        reviewsFull.innerHTML = reviewBadge;
      }

      const reviewsShort = card.querySelector('[data-july-reviews-short]');
      const avgEl = card.querySelector('[data-july-review-average]');
      const countEl = card.querySelector('[data-july-review-count]');
      const countNum = parseInt(reviewCount, 10) || 0;
      if (reviewsShort) {
        if (countNum > 0 && reviewAverage) {
          reviewsShort.hidden = false;
          if (avgEl) avgEl.textContent = reviewAverage;
          if (countEl) countEl.textContent = '(' + countNum + ')';
        } else {
          reviewsShort.hidden = true;
        }
      }
    }

    const atc = card.querySelector('[data-july-atc]');
    if (atc && variantId) {
      atc.setAttribute('product-id', variantId);
      atc.setAttribute('data-id', variantId);
    }
    if (atc && handle) {
      atc.setAttribute('data-handle', handle);
    }
    if (atc && url) {
      atc.setAttribute('data-pdp-link', url);
    }

    if (productId) card.setAttribute('data-product-id', productId);
    if (handle) card.setAttribute('data-product-handle', handle);
    if (url) card.setAttribute('data-product-url', url);
    if (variantId) card.setAttribute('data-variant-id', variantId);
    if (isPrescription && lensColor) {
      card.setAttribute('data-lens-color', lensColor);
    }

    syncJulyAtcFromCard(card);

    card.querySelectorAll('.july-swatch').forEach(function (btn) {
      let match = false;
      if (isPrescription && lensColor) {
        match = normalizeRxColor(btn.getAttribute('data-lens-color')) === normalizeRxColor(lensColor);
      } else if (isPrescription && imageUrl) {
        match = btn.getAttribute('data-image-url') === imageUrl;
      } else {
        match = btn.getAttribute('data-product-id') === productId;
      }
      btn.classList.toggle('is-active', match);
    });
  }

  function applyPrescriptionLensFromUrl(card) {
    if (!card || card.getAttribute('data-product-type') !== 'Prescription') return;
    if (card.dataset.julyRxLensApplied === 'true') return;

    const lensColor = getLensColorFromPageUrl();
    if (!lensColor) return;

    const matchingSwatch = Array.prototype.find.call(
      card.querySelectorAll('.july-swatch[data-lens-color]'),
      function (btn) {
        return normalizeRxColor(btn.getAttribute('data-lens-color')) === normalizeRxColor(lensColor);
      }
    );

    if (matchingSwatch) {
      updateCardFromSwatch(card, matchingSwatch);
      card.dataset.julyRxLensApplied = 'true';
      return;
    }

    let images = [];
    try {
      images = JSON.parse(card.getAttribute('data-rx-images') || '[]');
    } catch (error) {
      images = [];
    }

    const targetUrl = findRxLensImageUrl(images, lensColor);
    if (!targetUrl) return;

    const image = card.querySelector('[data-july-image]');
    if (image) {
      image.dataset.julyDefaultSrc = targetUrl;
      image.src = targetUrl;
    }

    const productUrl = card.getAttribute('data-product-url') || '';
    const baseUrl = productUrl.split('?')[0];
    const lensUrl = baseUrl + '?lens=rx-lens-color-' + lensColor;
    card.setAttribute('data-product-url', lensUrl);
    card.setAttribute('data-lens-color', lensColor);
    card.querySelectorAll('[data-july-link]').forEach(function (el) {
      el.setAttribute('href', lensUrl);
    });

    syncJulyAtcFromCard(card);

    card.dataset.julyRxLensApplied = 'true';
  }

  function addToCart(button) {
    const variantId = button.getAttribute('product-id');
    if (!variantId) return;

    const original = button.textContent;
    button.classList.add('is-loading');
    button.textContent = 'Adding';
    button.disabled = true;

    fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify({
        id: variantId,
        quantity: 1,
        sections: ['cart-drawer', 'header-classic']
      })
    })
      .then(function (res) {
        return res.json();
      })
      .then(function (res) {
        button.textContent = 'Added';
        if (res.sections && res.sections['cart-drawer'] && window.jQuery) {
          window.jQuery('#shopify-section-cart-drawer .section_holder').html(
            window.jQuery(res.sections['cart-drawer']).find('.section_holder').html()
          );
        }
        if (res.sections && res.sections['header-classic']) {
          const bubble = new DOMParser()
            .parseFromString(res.sections['header-classic'], 'text/html')
            .querySelector('.header-cart__count');
          if (bubble) {
            document.querySelectorAll('.header-cart__count').forEach(function (element) {
              element.innerHTML = bubble.innerHTML;
              if (+bubble.textContent > 0) {
                element.style.display = '';
              }
            });
          }
        }
        if (typeof window.open_slider_cart === 'function') {
          window.open_slider_cart();
        }
        setTimeout(function () {
          button.textContent = original;
          button.disabled = false;
          button.classList.remove('is-loading');
        }, 1200);
      })
      .catch(function () {
        button.textContent = original;
        button.disabled = false;
        button.classList.remove('is-loading');
      });
  }

  function canUseJulyHover() {
    return (
      window.matchMedia('(hover: hover) and (pointer: fine)').matches &&
      window.matchMedia('(min-width: 769px)').matches
    );
  }

  function lockJulyHoverFootprint(card) {
    if (!card || card.dataset.julyHeightLocked === 'true') return;
    const cardHeight = Math.ceil(card.getBoundingClientRect().height);
    if (cardHeight > 0) {
      card.style.height = cardHeight - 1 + 'px';
      card.dataset.julyHeightLocked = 'true';
    }

    const row = card.closest('.collection-matrix__row');
    if (row && row.dataset.julyHeightLocked !== 'true') {
      const rowHeight = Math.ceil(row.getBoundingClientRect().height);
      if (rowHeight > 0) {
        row.style.minHeight = rowHeight - 1 + 'px';
        row.dataset.julyHeightLocked = 'true';
      }
    }
  }

  function unlockJulyHoverFootprint(card) {
    if (!card) return;
    card.style.height = '';
    delete card.dataset.julyHeightLocked;

    const row = card.closest('.collection-matrix__row');
    if (!row) return;
    if (row.querySelector('.july-card.is-july-hover')) return;
    row.style.minHeight = '';
    delete row.dataset.julyHeightLocked;
  }

  function clearJulyHoverStates(scope) {
    (scope || document).querySelectorAll('.july-card.is-july-hover').forEach(function (card) {
      card.classList.remove('is-july-hover');
      restoreJulyDefaultImage(card);
      unlockJulyHoverFootprint(card);
    });
  }

  function initJulySwatchSlider(el) {
    if (!el || el.swiper || typeof Swiper === 'undefined') return null;

    // Nav may be siblings inside .july-card__hover-swatches (hover) or children of swiper (default).
    const navRoot = el.closest('.july-card__hover-swatches') || el;
    const prevEl = navRoot.querySelector('.july-swatches__nav--prev');
    const nextEl = navRoot.querySelector('.july-swatches__nav--next');

    const slideCount = el.querySelectorAll('.swiper-slide').length;
    if (slideCount <= 1) {
      if (prevEl) prevEl.classList.add('swiper-button-lock');
      if (nextEl) nextEl.classList.add('swiper-button-lock');
      return null;
    }

    const swiper = new Swiper(el, {
      slidesPerView: 'auto',
      spaceBetween: 6,
      watchOverflow: true,
      centerInsufficientSlides: true,
      resistanceRatio: 0.65,
      navigation: {
        nextEl: nextEl,
        prevEl: prevEl
      }
    });

    // Keep currently shown style in view on first init (and later reinits).
    const slides = el.querySelectorAll('.swiper-slide');
    let activeIndex = -1;
    for (let i = 0; i < slides.length; i++) {
      if (slides[i].querySelector('.july-swatch.is-active')) {
        activeIndex = i;
        break;
      }
    }
    if (activeIndex > 0) {
      swiper.slideTo(activeIndex, 0);
    }

    return swiper;
  }

  function initJulyHoverSwatchSlider(card) {
    const el = card.querySelector('.july-card__hover-swatches .july-swatches--hover.swiper');
    initJulySwatchSlider(el);
  }

  function bindJulyCardHover(card) {
    const surface = card.querySelector('.july-card__surface');
    if (!surface) return;

    card.addEventListener('mouseenter', function () {
      if (!canUseJulyHover()) return;
      // Lock grid footprint before surface goes absolute (otherwise row collapses).
      lockJulyHoverFootprint(card);
      card.classList.add('is-july-hover');
      applyJulyHoverImage(card);
      initJulyHoverSwatchSlider(card);
      const swiperEl = card.querySelector('.july-card__hover-swatches .swiper');
      if (swiperEl && swiperEl.swiper) {
        swiperEl.swiper.update();
      }
    });

    card.addEventListener('mouseleave', function () {
      card.classList.remove('is-july-hover');
      restoreJulyDefaultImage(card);
      unlockJulyHoverFootprint(card);
    });
  }

  function initJulyGrid(root) {
    const scope = root || document;

    scope.querySelectorAll('.july-card').forEach(function (card) {
      if (card.dataset.julyReady === 'true') return;
      card.dataset.julyReady = 'true';

      applyPrescriptionLensFromUrl(card);
      applyOphthalmicTypeFromUrl(card);
      applySafetyLensFromUrl(card);
      bindJulyCardHover(card);

      card.addEventListener('click', function (event) {
        const swatch = event.target.closest('.july-swatch');
        if (swatch && card.contains(swatch)) {
          event.preventDefault();
          event.stopPropagation();
          updateCardFromSwatch(card, swatch);
          return;
        }

        const atc = event.target.closest('[data-july-atc]');
        if (atc && card.contains(atc)) {
          event.preventDefault();
          event.stopPropagation();
          handleJulyAtcClick(card, atc);
        }
      });
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initJulyGrid(document);
    if (typeof window.filterSafetySplitCards === 'function') window.filterSafetySplitCards();
  });

  window.addEventListener('resize', function () {
    if (!canUseJulyHover()) clearJulyHoverStates(document);
    document.querySelectorAll('.july-card .july-swatches.swiper').forEach(function (el) {
      if (el.swiper) el.swiper.update();
    });
  });

  window.initJulyGrid = initJulyGrid;
})();
